var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "121.192%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "57mifs2pna"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "121.192%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "zea65v14ob"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .852)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#57mifs2pna)",
    strokeWidth: 1.175,
    fill: "#FFF",
    x: 0.587,
    y: 0.587,
    width: 88.825,
    height: 88.825,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.317 13.61 6.03-11.492a1.42 1.42 0 0 0 0-1.46A1.522 1.522 0 0 0 29.05 0h-7.958a1.513 1.513 0 0 0-1.342.804L15.274 9.33 10.752.804A1.511 1.511 0 0 0 9.456 0H1.498A1.518 1.518 0 0 0 .202.701a1.42 1.42 0 0 0 0 1.46L6.23 13.654c.26.486.777.79 1.341.789h3.406a6.27 6.27 0 0 0-.331 2 7.484 7.484 0 0 0 0 .818c-5.702 2.162-9.008 7.95-7.873 13.778 1.136 5.83 6.392 10.05 12.515 10.05s11.38-4.22 12.515-10.05c1.136-5.829-2.17-11.616-7.873-13.778.041-.28.066-.563.076-.847a6.63 6.63 0 0 0-.211-2.015h3.3a1.51 1.51 0 0 0 1.221-.788zm-1.386 13.142-3.844 3.635.905 5.14-4.718-2.453-4.763 2.424.905-5.14-3.844-3.636 5.32-.744 2.382-4.688 2.381 4.688 5.276.774zm-5.954-10.324v.102a13.429 13.429 0 0 0-1.703-.16c-.55 0-1.099.04-1.643.116a.184.184 0 0 1 0-.087 3.158 3.158 0 0 1 .648-2h2.11c.435.58.658 1.283.633 2l-.045.029z",
    transform: "translate(30.548 25.827)",
    fill: "url(#zea65v14ob)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.3b2955a5f22daabee8f324892cb2704d.svg";
export { ForwardRef as ReactComponent };